export default "__VITE_ASSET__DZfFoHWI__"